import PropTypes from 'prop-types';
import { MetricsTracker, USER_EVENTS } from '@sm/metrics';
import getLinkWithParams from './getLinkWithParams';

const buildEventData = actionFlow => (actionType, data = {}) => ({
  data: {
    actionFlow,
    actionType,
    ...data,
  },
});

const trackEvent = actionFlow => (actionType, data) => {
  MetricsTracker.track({
    name: USER_EVENTS.ELEMENT_INTERACTION,
    ...buildEventData(actionFlow)(actionType, data),
  });
};

const createLogger = actionFlow => ({
  trackEvent: trackEvent(actionFlow),
  buildEventData: buildEventData(actionFlow),
});

export const LOGGER_NAME = Object.freeze({
  SOLUTIONS: 'solutions',
  NAV: 'nav',
});

const LOGGERS = {
  [LOGGER_NAME.SOLUTIONS]: createLogger('mrx_solutions'),
  [LOGGER_NAME.NAV]: createLogger('mrx_navigation_menu'),
};

const removeSpaces = str => str.replace(' ', '_');

const getLogger = loggerName => ({
  click: {
    learnMore: moduleTitle => LOGGERS[loggerName].trackEvent(`CLICK_${removeSpaces(moduleTitle)}_LEARN_MORE`),
    getStarted: moduleTitle => LOGGERS[loggerName].trackEvent(`CLICK_${removeSpaces(moduleTitle)}_TRY_IT_NOW`),
    navigateTo: dest => LOGGERS[loggerName].trackEvent(`CLICK_NAVIGATE_TO_${removeSpaces(dest)}`),
    contactUs: moduleTitle => LOGGERS[loggerName].trackEvent(`CLICK_${removeSpaces(moduleTitle)}_CONTACT_US`),
  },
  action: {},
});

export const loggerPropType = PropTypes.shape({
  click: PropTypes.shape({
    learnMore: PropTypes.func.isRequired,
    getStarted: PropTypes.func.isRequired,
    navigateTo: PropTypes.func.isRequired,
    contactUs: PropTypes.func.isRequired,
  }),
});

export const getLinkGenerator = config => {
  const { ut_source: utSource, ut_source2: utSource2, ut_source3: utSource3 } = config;
  return (link, conf = {}) => {
    const { ut_source3: utSource3sub, ut_ctatext: utCtaText, anchor } = conf;
    const linkConfig = {
      queryParams: {
        ut_source: utSource,
        ut_source2: utSource2,
      },
    };
    if (utSource3 || utSource3sub) {
      linkConfig.queryParams.ut_source3 = utSource3sub || utSource3;
    }
    if (utCtaText) linkConfig.queryParams.ut_ctatext = utCtaText;
    if (anchor) linkConfig.anchor = anchor;
    return getLinkWithParams(link, linkConfig);
  };
};

export default getLogger;
